export default __webpack_public_path__ + "static/media/Intro - Mix Workspace.b2f36bb3.pdf";